export const REGULATIONS_TRANSLATION_NAMESPACE = 'features/regulations';
